import {
  FormSelectableWithImageAndDescription,
  HomeTypeName,
} from "@covertree/types";

export const homeTypes: Record<
  HomeTypeName,
  FormSelectableWithImageAndDescription
> = {
  SingleWide: {
    name: "Single wide",
    description:
      "A Manufactured home transported to the site as a single unit. (Usually 500 to 1,200 sq ft)",
    image: "/images/home-types/single-wide.png",
  },
  DoubleWide: {
    name: "Double wide",
    description:
      "A Manufactured home transported to the site as two units and then combined/married at the site. (Usually 1,000 to 2,200 sq ft)",
    image: "/images/home-types/double-wide.png",
  },
  TripleWide: {
    name: "Triple wide",
    description:
      "A Manufactured home transported to the site as three units and then combined/married at the site. (Usually 2,000+ sq ft)",
    image: "/images/home-types/triple-wide.png",
  },
  Modular: {
    name: "Modular",
    description:
      "A housing unit assembled from multiple prefabricated parts. It is designed to be used as a dwelling with a permanent foundation when connected to required utilities. The dwelling does not have a chassis and is built to local building codes rather than HUD code.",
    image: "/images/home-types/modular.png",
  },
  Duplex: {
    name: "Duplex",
    description:
      "A manufactured home duplex is a single structure with two living units attached to each other. It may be delivered in sections.",
  },
  CrossMod: {
    name: "CrossMod",
    description:
      'A CrossMod is a manufactured home designed to meet Fannie Mae and Freddie Mac financing guidelines. Defining features include a garage/carport, higher roof pitch, increased energy efficiency, and designated as "real" property.',
  },
  ParkModel: {
    name: "Park model",
    description:
      "Are intended to provide temporary accommodations, meet ANSI housing standards, and are 400 sq ft or less.",
    image: "/images/home-types/park-model.png",
  },
  TinyHome: {
    name: "Tiny home",
    description:
      "Are usually 400 or less sq ft. They may also be built on a chassis and have wheels but not all homes will.",
    image: "/images/home-types/tiny-home.png",
  },
  AccessoryDwellingUnit: {
    name: "Accessory dwelling unit",
    description:
      'An "in-law apartment" placed on the property of the main home. They are often put in place to support multi-generational families.',
    image: "/images/home-types/accessory-dwelling-unit.png",
  },
  StationaryTravelTrailer: {
    name: "Stationary travel trailer",
    description:
      "A travel trailer that is no longer moved from location to location. They must be connected to utilities and often have decks or other permanent living enhancements near by.",
    image: "/images/home-types/stationary-travel-trailer.png",
  },
  Unknown: {
    name: "Unknown",
    description: "Unknown home type",
    image: "/images/home-types/coming-soon.png",
  },
};
